import React from 'react';

const About = () => {
    return (
        <div className='mx-auto'>
            <h1 > About us</h1>
        </div>
    );
};

export default About;